import React, { Suspense } from 'react';
import {BrowserRouter} from "react-router-dom";
import {AppRoutes} from "./providers";
import {MantineProvider} from '@mantine/core';
import {Notifications} from "@mantine/notifications";
import { FormProvider, useForm } from './providers';
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/core/styles.css';

export const App = () => {

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      company: '',
      phone: '',
      email: '',
      message: '',
      check: false,
    },
    validate: {
      name: (value) => (!value ? 'Обязательное поле' : null),
      email: (value) => {
        if (!value) return 'Обязательное поле';

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        return !emailRegex.test(value) ? 'Некорректный email' : null;
      },
      phone: (value) => {
        const digits = value.replace(/\D/g, '');

        if (!digits) return 'Обязательное поле';

        if (digits.length < 11) {
          return 'Заполните номер телефона';
        }

        return null;
      },
      check: (value) => (!value ? 'Необходимо согласие на обработку данных' : null),
    },
  });

  return (
    <MantineProvider>
      <Notifications />
      <BrowserRouter>
        <Suspense fallback={<></>}>
          <FormProvider form={form}>
            <AppRoutes />
          </FormProvider>
        </Suspense>
      </BrowserRouter>
    </MantineProvider>
  );
}